import SalesOrdersPage from "../../pages/legacy/salesOrders/SalesOrdersPage";

const route = {
  key: "salesOrders",
  path: "/legacy/sales-table",
  component: SalesOrdersPage,
  private: true,
  layout: "main",
  icon: "faFileInvoice",
  group: "sales",
  order: 20,
  permission: "legacy.salesOrders.read"
};

export default route;